/*
 * ALMA - Atacama Large Millimeter Array
 * Copyright (c) ESO - European Southern Observatory, 2011
 * (in the framework of the ALMA collaboration).
 * All rights reserved.
 * 
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 * 
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 * 
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 59 Temple Place, Suite 330, Boston, MA 02111-1307  USA
 */

import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ColumnMode} from '@almaobservatory/ngx-datatable';
import {StickyPopover} from 'asax-common';

@Component({
  selector: 'asax-sky-view-aladin-popover-search-radius',
  templateUrl: './aladin-popover-search-radius.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [],
  encapsulation: ViewEncapsulation.None
})
export class AladinPopoverSearchRadiusComponent implements OnChanges {

  @ViewChild('stickyPopover', {static: true}) stickyPopover: StickyPopover;

  @Input() searchRadius: any;

  ColumnMode = ColumnMode;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.searchRadius) {
      this.onsearchRadius();
    }
  }

  close(): void {
    this.stickyPopover?.close();
  }

  private onsearchRadius(): void {
    if (this.searchRadius) {
      this.stickyPopover?.open();
    } else {
      this.stickyPopover?.close();
    }
  }
}